/**
 *
 * FormController
 *
 */

import PropTypes from 'prop-types';
import React from 'react';

import APIKeys from './APIKeys';
import APILogs from './APILogs';
import AccountNotFound from './AccountNotFound';
import ActiveDot from './ActiveDot';
import ActiveStatus from './ActiveStatus';
import AddButton from './AddButton';
import Addition from './Addition';
import Agent from './Agent';
import Alert from './Alert';
import AlertInfo from './AlertInfo';
import AppleAppIcon from './AppleAppIcon';
import AppsV2 from './AppsV2';
import Arrow from './Arrow';
import Atom from './Atom';
import Attach from './Attach';
import BackArrow from './BackArrow';
import BankDetails from './Bank-details';
import BankLogo from './BankLogo';
import BarGraph from './BarGraph';
import Block from './Block';
import Box from './Box';
import BulkPayments from './BulkPayments';
import BulkSubscriptions from './BulkSubscriptions';
import CCAvenue from './CCAvenue';
import Camera from './Camera';
import Cancel from './Cancel';
import CashfreeFullLogo from './CashfreeFullLogo';
import CashfreeLogo from './CashfreeLogo';
import ChartLine from './ChartLine';
import ChevronDown from './ChevronDown';
import CircularClose from './CircularClose';
import CircularInfo from './CircularInfo';
import CircularPending from './CircularPending';
import Clock from './Clock';
import Close from './Close';
import CloseNormal from './CloseNormal';
import CloseSmall from './CloseSmall';
import Comment from './Comment';
import CopyToClipboard from './CopyToClipboard';
import Cred from './Cred';
import CreditCard from './CreditCard';
import CsvFile from './CsvFile';
import CustomerLifeCycleAnalysis from './CustomerLifeCycleAnalysis';
import Date from './Date';
import Delete from './Delete';
import DeleteInfo from './DeleteInfo';
import DeleteSplit from './DeleteSplit';
import Delhivery from './Delhivery';
import DeltaArrowDown from './DeltaArrowDown';
import DeltaArrowUp from './DeltaArrowUp';
import Desktop from './Desktop';
import Developers from './Developers';
import Document from './Document';
import Dot from './Dot';
import DottedLine from './DottedLine';
import DownTime from './DownTime';
import Download from './Download';
import DownloadOutline from './DownloadOutline';
import Dream11 from './Dream11';
import EasySplit from './EasySplit';
import Edit from './Edit';
import Ellipse from './Ellipse';
import EllipsisHorizontal from './EllipsisHorizontal';
import Email from './Email';
import EposActive from './EposActive';
import EposInactive from './EposInactive';
import Error from './Error';
import Exclamation from './Exclamation';
import ExclusiveAccess from './ExclusiveAccess';
import Expand from './Expand';
import Eye from './Eye';
import EyeSlash from './EyeSlash';
import Failed from './Failed';
import FailedBig from './FailedBig';
import FeeWallet from './FeeWallet';
import File from './File';
import FileFormat from './FileFormat';
import Flash from './Flash';
import FlowWise from './FlowWise';
import ForwardArrow from './ForwardArrow';
import GerneralInfo from './General-info';
import GenericFile from './GenericFile';
import GooglePay from './GooglePay';
import GooglePlay from './GooglePlay';
import GooglePlayIcon from './GooglePlayIcon';
import GreenTick from './GreenTick';
import GreenTickBig from './GreenTickBig';
import GreenTickSmall from './GreenTickSmall';
import GroupPeople from './GroupPeople';
import Help from './Help';
import Home from './Home';
import HomeCredit from './HomeCredit';
import HourGlass from './HourGlass';
import ImportMandates from './ImportMandates';
import InActiveStatus from './InActiveStatus';
import IncidentWarning from './IncidentWarning';
import Info from './Info';
import InstaCred from './InstaCred';
import InsufficientEvidence from './InsufficientEvidence';
import IntegrationForm from './IntegrationForm';
import IntegrationUsage from './IntegrationUsage';
import InternationalCards from './InternationalCards';
import Irctc from './Irctc';
import LeftArrowWithShadow from './LeftArrowWithShadow';
import LeftButton from './LeftButton';
import LeftChevron from './LeftChevron';
import Lightning from './Lightning';
import Line from './Line';
import Link from './Link';
import Lock from './Lock';
import MoreInfo from './MoreInfo';
import MoveDown from './MoveDown';
import MultilineText from './MultilineText';
import NavigateTo from './NavigateTo';
import NetBanking from './NetBanking';
import NewTab from './NewTab';
import NoIncident from './NoIncdent';
import NumberIcon from './Number';
import Nykaa from './Nykaa';
import Offers from './Offers';
import OpenLink from './OpenLink';
import OpenNewTab from './OpenNewTab';
import Optional from './Optional';
import PayU from './PayU';
import PaymentForms from './PaymentForms';
import PaymentLinks from './PaymentLinks';
import Paypal from './Paypal';
import Paytm from './Paytm';
import Pending from './Pending';
import Phone from './Phone';
import PhonePe from './Phonepe';
import PigiBank from './PigiBank';
import Plans from './Plans';
import ProductLinks from './ProductLinks';
import QRCode from './QRCode';
import QuickActivate from './QuickActivate';
import Radio from './Radio';
import RateLimits from './RateLimits';
import Razorpay from './Razorpay';
import Refresh from './Refresh';
import Refund from './RefundIcon';
import RemoveButton from './RemoveButton';
import Reports from './Reports';
import Retry from './Retry';
import RightArrowWithShadow from './RightArrowWithShadow';
import RightButton from './RightButton';
import RiskShield from './Riskshield';
import RoundedAdd from './RoundedAdd';
import RoundedCross from './RoundedCross';
import Router from './Router';
import RouterV2 from './RouterV2';
import Search from './Search';
import Send from './Send';
import ServiceAlerts from './ServiceAlerts';
import Settings from './Settings';
import Settlements from './Settlements';
import Share from './Share';
import Shopify from './Shopify';
import SideArrow from './SideArrow';
import Simpl from './Simpl';
import Slack from './Slack';
import SoftPOS from './SoftPOS';
import Star from './Star';
import Stars from './Stars';
import StatusPage from './StatusPage';
import Storefront from './Storefront';
import Subscriptions from './Subscriptions';
import Subtract from './Subtract';
import SuccessTick from './SuccessTick';
import Summary from './Summary';
import Switch from './Switch';
import TechProcess from './TechProcess';
import SandTimer from './SandTimer';
import Rocket from './Rocket';
import Test from './Test';
import Text from './Text';
import Tick from './Tick';
import TickWithCircle from './TickWithCircle';
import Timer from './Timer';
import Transactions from './Transactions';
import Upi from './Upi';
import UploadDocs from './Upload-docs';
import UploadCloud from './UploadCloud';
import UploadCloudSmall from './UploadCloudSmall';
import UploadIcon from './UploadIcon';
import Url from './Url';
import Verified from './Verified';
import Visibility from './Visibility';
import Wallet from './Wallet';
import WalletBanner from './WalletBanner';
import WalletRefund from './WalletRefund';
import GreenTickDot from './GreenTickDot';
import BlueDot from './BlueDot';
import GreyDot from './GreyDot';
import Warning from './Warning';
import Webhooks from './Webhooks';
import WhatsApp from './WhatsApp';
import WhatsappGreen from './WhatsappGreen';
import Whitelisting from './Whitelisting';
import Zomato from './Zomato';
import Urgent from './Urgent';
import Mobile from './Mobile';
import BrandingDesktop from './BrandingDesktop';
import Restore from './Restore';
import TightDisplay from './TightDisplay';
import MediumDisplay from './MediumDisplay';
import LooseDisplay from './LooseDisplay';
import JointDisplay from './JointDisplay';
import SpacedDisplay from './SpacedDisplay';
import FullSizeCardDisplay from './FullSizeCardDisplay';
import MediumSizeCardDisplay from './MediumSizeCardDisplay';
import InputAllSidesDisplay from './InputAllSidesDisplay';
import InputBottomDisplay from './InputBottomDisplay';
import InputThreeSidesDisplay from './InputThreeSidesDisplay';
import OutlinedIcon from './OutlinedIcon';
import ThreeDimensionalIcon from './ThreeDimensionalIcon';
import FilledIcon from './FilledIcon';
import Analytics from './Analytics';
import Apps from './Apps';
import VBA from './VBA';
import Replay from './Replay';
import Play from './Play';
import PlayCircle from './PlayCircle';
import Book from './Book';
import AppleStore from './AppleStore';
import Playstore from './Playstore';
import AppQRCode from './AppQRCode';
import MobileAppInHand from './MobileAppInHand';
import Ecom360 from './Ecom360';
import Live from './Live';
import Ecom360Logo from './Ecom360Logo';
import AddQR from './AddQR';
import Lyra from './Lyra';
import Stripe from './Stripe';
import BrokenError from './BrokenError';
import StackedPointer from './StackedPointer';
import Sparkles from './Sparkles';
import RaiseTicket from './RaiseTicket';
import EmbeddableComponents from './EmbeddableComponents';
import TestConfig from './TestConfig';
import UpiPaymentIcon from './UpiPaymentIcon';
import CardPaymentIcon from './CardPaymentIcon';
import BNPLPaymentIcon from './BNPLPaymentIcon';
import WalletPaymentIcon from './WalletPaymentIcon';
import PaypalPaymentIcon from './PaypalPaymentIcon';
import CardEmiPaymentIcon from './CardEmiPaymentIcon';
import NetBankingPaymentIcon from './NetBankingPaymentIcon';
import CardlessEMIPaymentIcon from './CardlessEMIPaymentIcon';
import BharatXPaymentIcon from './BharatXPaymentIcon';
import BankTransferPaymentIcon from './BankTransferPaymentIcon';
import CODPaymentIcon from './CODPaymentIcon';
import DragAndDrop from './DragAndDrop';
import RouterConfiguration from './RouterConfiguration';
import RouterGateways from './RouterGateways';
import SettlementRecon from './SettlementRecon';
import CheckoutCustomisations from './CheckoutCustomisations';
import InsightsAI from './InsightsAI';
import Rupee from './Rupee';
import Payments from './Payments';
import AiCheckoutPersonalisation from './AiCheckoutPersonalisation';
import Website from './Website';
import AnalyticsV2 from './AnalyticsV2';
import ReflectPlay from './ReflectPlay';
import PaymentsVerification from './PaymentsVerification';
import Location from './Location';
import Documents from './Documents';
import Person from './Person';
import Mail from './Mail';
import CloudSync from './CloudSync';
import CheckCircle from './CheckCircle';
import WarningNew from './WarningNew';
import RadioBoxIcon from './RadioBoxIcon';
import FilledInfo from './FilledInfo';
import Percentage from './Percentage';
import SealWarning from './SealWarning';
import SealSuccess from './SealSuccess';
import CreditCardPayment from './CreditCardPayment';
import Wallets from './Wallets';
import PayLater from './PayLater';
import NetBankingPayments from './NetBankingPayments';
import CharmTick from './CharmTick';
import CashOnDeliveryIcon from './CashOnDeliveryIcon';
import CardLessEMI from './CardLessEMI';
import CardEMI from './CardEMI';
import RadioBoxIconV1 from './RadioBoxIconV1';

// Types
import { ICON_NAME, IconProps } from './types';
import CustomRouting from './CustomRouting';
import SuccessRouting from './SuccessRouting';
import VolumeRouting from './VolumeRouting';
import User from './User';
import Workflows from "./Workflows";
import NewIcon from "./NewIcon";
import Flows from "./Flows";
import Connections from "./Connections";
import Runs from "./Runs";
import TimeZoneComponent from './TimeZoneComponent';

export function CustomIcon({ componentName, ...props }: IconProps) {
  const componentMapper: Record<string, React.ComponentType> = {
    GENERAL_INFORMATION: GerneralInfo,
    BANK_DETAILS: BankDetails,
    UPLOAD_DOCUMENTS: UploadDocs,
    DEFAULT_STATUS: GerneralInfo,
    BACK_ARROW: BackArrow,
    EXCLAMAITON: Exclamation,
    HOME: Home,
    LEFTCHEVRON: LeftChevron,
    REFUND: Refund,
    CIRCULARINFO: CircularInfo,
    LIGHTNING: Lightning,
    COPY_TO_CLIPBOARD: CopyToClipboard,
    COMMENT: Comment,
    CHEVRONDOWN: ChevronDown,
    CLOSE: Close,
    GREEN_TICK: GreenTick,
    PENDING: Pending,
    FAILED: Failed,
    BOX: Box,
    CLOSE_SMALL: CloseSmall,
    ALERT: Alert,
    EDIT: Edit,
    ACTIVATE: Tick,
    DOWNLOAD: Download,
    RETRY: Retry,
    DEVELOPERS: Developers,
    PAYMENT_LINKS: PaymentLinks,
    PAYMENT_FORMS: PaymentForms,
    PAYMENT_BUTTONS: PaymentForms,
    CUSTOMERS: GroupPeople,
    PRODUCT_LINKS: ProductLinks,
    REPORTS: Reports,
    API_KEYS: APIKeys,
    SETTLEMENTS: Settlements,
    SUMMARY: Summary,
    TRANSACTIONS: Transactions,
    SHARE: Share,
    OPEN_LINK: OpenLink,
    ADDITION: Addition,
    SUBTRACT: Subtract,
    UPLOAD_CLOUD: UploadCloud,
    MOVE_DOWN: MoveDown,
    NUMBER: NumberIcon,
    MULTILINE_TEXT: MultilineText,
    TEXT: Text,
    DELETE: Delete,
    GREEN_TICK_BIG: GreenTickBig,
    MORE_INFO: MoreInfo,
    CSV_FILE: CsvFile,
    CLOSE_NORMAL: CloseNormal,
    SETTINGS: Settings,
    PAYPAL: Paypal,
    PHONEPE: PhonePe,
    PAYTM: Paytm,
    NETBANKING: NetBanking,
    NAVIGATE_TO: NavigateTo,
    EASY_SPLIT: EasySplit,
    DELETE_INFO: DeleteInfo,
    ACTIVE_STATUS: ActiveStatus,
    INACTIVE_STATUS: InActiveStatus,
    CIRCULAR_CLOSE: CircularClose,
    OPEN_NEW_TAB: OpenNewTab,
    DELETE_SPLIT: DeleteSplit,
    CIRCULAR_PENDING: CircularPending,
    EPOS_ACTIVE: EposActive,
    EPOS_INACTIVE: EposInactive,
    CREDITCARD: CreditCard,
    UPI: Upi,
    WALLET: Wallet,
    INSTACRED: InstaCred,
    INTERNATIONAL_CARDS: InternationalCards,
    TEST: Test,
    ALERT_INFO: AlertInfo,
    REMOVE_BUTTON: RemoveButton,
    ADD_BUTTON: AddButton,
    ELLIPSIS_HORIZONTAL: EllipsisHorizontal,
    ATTACH: Attach,
    UPLOAD_ICON: UploadIcon,
    SUBSCRIPTIONS: Subscriptions,
    PLANS: Plans,
    BULK_SUBSCRIPTIONS: BulkSubscriptions,
    IMPORT_MANDATES: ImportMandates,
    BULK_PAYMENTS: BulkPayments,
    NEWTAB: NewTab,
    EMAIL: Email,
    PHONE: Phone,
    WHATSAPP: WhatsApp,
    WHATSAPP_GREEN: WhatsappGreen,
    LINK: Link,
    CAMERA: Camera,
    REFRESH: Refresh,
    INFO: Info,
    DOWNLOAD_OUTLINE: DownloadOutline,
    URL: Url,
    VISIBILITY: Visibility,
    CANCEL: Cancel,
    SOFTPOS: SoftPOS,
    SEND: Send,
    OPTIONAL: Optional,
    DOWNTIME: DownTime,
    TIMER: Timer,
    GOOGLE_PLAY: GooglePlay,
    DESKTOP: Desktop,
    RADIO: Radio,
    ELLIPSE: Ellipse,
    LINE: Line,
    DOTTED_LINE: DottedLine,
    GREEN_TICK_SMALL: GreenTickSmall,
    SERVICE_ALERTS: ServiceAlerts,
    WEBHOOKS: Webhooks,
    API_LOGS: APILogs,
    WHITELISTING: Whitelisting,
    RATE_LIMITS: RateLimits,
    INTEGRATION_USAGE: IntegrationUsage,
    SWITCH: Switch,
    ROUTER: Router,
    FILE_FORMAT: FileFormat,
    GOOGLE_PAY: GooglePay,
    SIMPL: Simpl,
    HOME_CREDIT: HomeCredit,
    G_PLAY: GooglePlayIcon,
    A_APP: AppleAppIcon,
    ACCOUNT_NOT_FOUND: AccountNotFound,
    CRED: Cred,
    DELHIVERY: Delhivery,
    DREAM11: Dream11,
    IRCTC: Irctc,
    NYKAA: Nykaa,
    ZOMATO: Zomato,
    FORWARD_ARROW: ForwardArrow,
    EYE: Eye,
    EYE_SLASH: EyeSlash,
    OFFERS: Offers,
    DATE: Date,
    SEARCH: Search,
    APPS: Apps,
    SHOPIFY: Shopify,
    SLACK: Slack,
    FAILED_BIG: FailedBig,
    ROUTER_ANALYTICS: AnalyticsV2,
    ARROW: Arrow,
    DOT: Dot,
    ACTIVE_DOT: ActiveDot,
    ERROR: Error,
    UPLOAD_CLOUD_SM: UploadCloudSmall,
    FILE: File,
    VERIFIED: Verified,
    QR_CODE: QRCode,
    INTEGRATION_FORM: IntegrationForm,
    EXCLUSIVE_ACCESS: ExclusiveAccess,
    RIGHT_ARROW: RightArrowWithShadow,
    LEFT_ARROW: LeftArrowWithShadow,
    FLASH: Flash,
    CASHFREE_LOGO: CashfreeLogo,
    BANK_LOGO: BankLogo,
    EXPAND: Expand,
    BLOCK: Block,
    INSUFFICIENT_EVIDENCE: InsufficientEvidence,
    ROUNDED_ADD: RoundedAdd,
    ROUNDED_CROSS: RoundedCross,
    ROUTER_V2: RouterV2,
    APPS_V2: AppsV2,
    QUICK_ACTIVATE: QuickActivate,
    LOCK: Lock,
    WALLET_BANNER: WalletBanner,
    WALLET_REFUND: WalletRefund,
    FEE_WALLET: FeeWallet,
    HOUR_GLASS: HourGlass,
    CLOCK: Clock,
    STARS: Stars,
    INCIDENT_WARNING: IncidentWarning,
    NO_INCIDENT: NoIncident,
    STATUS_PAGE: StatusPage,
    HELP: Help,
    STOREFRONT: Storefront,
    AGENT: Agent,
    TICK_WITH_CIRCLE: TickWithCircle,
    SUCCESS_TICK: SuccessTick,
    RIGHT_BUTTON: RightButton,
    LEFT_BUTTON: LeftButton,
    RISKSHIELD: RiskShield,
    PIGI_BANK: PigiBank,
    FLOWWISE: FlowWise,
    BAR_GRAPH: BarGraph,
    DOCUMENT: Document,
    CUSTOMER_LIFECYCLE_ANALYSIS: CustomerLifeCycleAnalysis,
    CASHFREE_FULL_LOGO: CashfreeFullLogo,
    CCAVENUE: CCAvenue,
    PAYU: PayU,
    RAZORPAY: Razorpay,
    TECHPROCESS: TechProcess,
    DELTA_ARROW_UP: DeltaArrowUp,
    DELTA_ARROW_DOWN: DeltaArrowDown,
    CHART_LINE: ChartLine,
    GREEN_TICK_DOT: GreenTickDot,
    BLUE_DOT: BlueDot,
    GREY_DOT: GreyDot,
    ATOM: Atom,
    SAND_TIMER: SandTimer,
    ROCKET: Rocket,
    SIDE_ARROW: SideArrow,
    WARNING: Warning,
    URGENT: Urgent,
    MOBILE: Mobile,
    BRANDING_DESKTOP: BrandingDesktop,
    RESTORE: Restore,
    TIGHT_DISPLAY: TightDisplay,
    MEDIUM_DISPLAY: MediumDisplay,
    LOOSE_DISPLAY: LooseDisplay,
    JOINT_DISPLAY: JointDisplay,
    SPACED_DISPLAY: SpacedDisplay,
    FULL_SIZE_CARD_DISPLAY: FullSizeCardDisplay,
    MEDIUM_SIZE_CARD_DISPLAY: MediumSizeCardDisplay,
    INPUT_ALL_SIDES_DISPLAY: InputAllSidesDisplay,
    INPUT_BOTTOM_DISPLAY: InputBottomDisplay,
    INPUT_THREE_SIDES_DISPLAY: InputThreeSidesDisplay,
    OUTLINED_ICON: OutlinedIcon,
    THREE_DIMENSIONAL_ICON: ThreeDimensionalIcon,
    FILLED_ICON: FilledIcon,
    CHECKOUT_ANALYTICS: Analytics,
    VBA,
    STAR: Star,
    REPLAY: Replay,
    PLAY: Play,
    [ICON_NAME.PLAY_CIRCLE]: PlayCircle,
    BOOK: Book,
    APP_STORE: AppleStore,
    PLAY_STORE: Playstore,
    APP_QR_CODE: AppQRCode,
    MOBILE_APP_IN_HAND: MobileAppInHand,
    ECOM_360: Ecom360,
    LIVE: Live,
    ECOM_360_LOGO: Ecom360Logo,
    GENERIC_FILE: GenericFile,
    ADD_QR: AddQR,
    LYRA: Lyra,
    STRIPE: Stripe,
    BROKEN_ERROR: BrokenError,
    STACKED_POINTER: StackedPointer,
    SPARKLES: Sparkles,
    RAISE_TICKET: RaiseTicket,
    [ICON_NAME.EMBEDDABLE_COMPONENTS]: EmbeddableComponents,
    [ICON_NAME.TEST_CONFIG]: TestConfig,
    [ICON_NAME.DRAG_AND_DROP]: DragAndDrop,
    [ICON_NAME.UPI_PAYMENT_ICON]: UpiPaymentIcon,
    [ICON_NAME.CARD_PAYMENT_ICON]: CardPaymentIcon,
    [ICON_NAME.BNPL_PAYMENT_ICON]: BNPLPaymentIcon,
    [ICON_NAME.WALLET_PAYMENT_ICON]: WalletPaymentIcon,
    [ICON_NAME.PAYPAL_PAYMENT_ICON]: PaypalPaymentIcon,
    [ICON_NAME.CARD_EMI_PAYMENT_ICON]: CardEmiPaymentIcon,
    [ICON_NAME.NET_BANKING_PAYMENT_ICON]: NetBankingPaymentIcon,
    [ICON_NAME.CARDLESS_EMI_PAYMENT_ICON]: CardlessEMIPaymentIcon,
    [ICON_NAME.BHARATX_EMI_PAYMENT_ICON]: BharatXPaymentIcon,
    [ICON_NAME.BANK_TRANSFER_PAYMENT_ICON]: BankTransferPaymentIcon,
    [ICON_NAME.COD_PAYMENT_ICON]: CODPaymentIcon,
    ROUTER_CONIGURATION: RouterConfiguration,
    ROUTER_GATEWAYS: RouterGateways,
    SETTLEMENT_RECON: SettlementRecon,
    CHECKOUT_CUSTOMISATIONS: CheckoutCustomisations,
    INSIGHTS_AI: InsightsAI,
    RUPEE: Rupee,
    PAYMENTS: Payments,
    [ICON_NAME.AI_CHECKOUT_PERSONALISATION]: AiCheckoutPersonalisation,
    [ICON_NAME.WEBSITE]: Website,
    [ICON_NAME.REFLECT_PLAY]: ReflectPlay,
    [ICON_NAME.CUSTOM_ROUTING]: CustomRouting,
    [ICON_NAME.SUCCESS_ROUTING]: SuccessRouting,
    [ICON_NAME.VOLUME_ROUTING]: VolumeRouting,
    PAYMENTS_VERIFICATION: PaymentsVerification,
    [ICON_NAME.LOCATION]: Location,
    [ICON_NAME.DOCUMENTS]: Documents,
    [ICON_NAME.PERSON]: Person,
    [ICON_NAME.MAIL]: Mail,
    [ICON_NAME.CLOUDSYNC]: CloudSync,
    [ICON_NAME.CHECKCIRCLE]: CheckCircle,
    [ICON_NAME.WARNINGNEW]: WarningNew,
    [ICON_NAME.USER]: User,
    [ICON_NAME.RADIO_BOX_ICON]: RadioBoxIcon,
    [ICON_NAME.FILLED_INFO]: FilledInfo,
    [ICON_NAME.PERCENTAGE]: Percentage,
    [ICON_NAME.SEAL_WARNING]: SealWarning,
    [ICON_NAME.SEAL_SUCCESS]: SealSuccess,
    CREDIT_CARD_PAYMENT: CreditCardPayment,
    WALLETS: Wallets,
    PAY_LATER: PayLater,
    NETBANKING_PAYMENTS: NetBankingPayments,
    CHARMTICK: CharmTick,
    CODICON: CashOnDeliveryIcon,
    CARDLESSEMI: CardLessEMI,
    CARDEMI: CardEMI,
    TIMEZONE: TimeZoneComponent,
    [ICON_NAME.RADIO_BOX_ICON_V1]: RadioBoxIconV1,
    [ICON_NAME.WORKFLOWS]:Workflows,
    [ICON_NAME.FLOWS]:Flows,
    [ICON_NAME.RUNS]:Runs,
    [ICON_NAME.CONNECTIONS]:Connections,
    [ICON_NAME.NEWICON]:NewIcon,
  };

  const TagName = componentMapper[componentName];
  return componentName ? <TagName {...props} key={componentName} /> : null;
}

CustomIcon.propTypes = {
  componentName: PropTypes.any,
  header: PropTypes.any,
  subheaders: PropTypes.any,
  className: PropTypes.any,
};

// eslint-disable-next-line no-undef
export default CustomIcon;
